import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 交易币支付
interface OrderTradePayJson {
    order_id: string
}
export const orderTradePay = (json: OrderTradePayJson): any => http.httpPost({
    url: httpApi.pay.orderTradePay,
    json
})

// h5支付
interface HPayJson {
    order_id: string,
    pay_type: string,
    token: string,
}
export const hpay = (json: HPayJson): any => http.httpGet({
    url: httpApi.pay.hpay,
    json
})

// 提现配置
interface ExtractInfoJson {
    token: string,
    type: number,
    need_extract_info: number,
    need_read_status: number,
    extract_type: number
}
export const extractInfo = (json: ExtractInfoJson): any => http.httpPost({
    url: httpApi.pay.extractInfo,
    json
})

// 提现申请
interface ExtractApplyJson {
    type: number,
    money: number,
    alipay_account: string,
    extract_type: number,
}
export const extractApply = (json: ExtractApplyJson): any => http.httpPost({
    url: httpApi.pay.extractApply,
    json
})

// 提现申请列表
interface ExtractrListJson {
    token: string,
    type: number,
    page: number,
    size: number
}
export const extractrList = (json: ExtractrListJson): any => http.httpPost({
    url: httpApi.pay.extractrList,
    json
})

// 提现申请列表小红点状态
interface EeadExtractJson {
    type: number
}

export const readExtract = (json: EeadExtractJson): any => http.httpPost({
    url: httpApi.pay.readExtract,
    json
})


// 游戏充值档位
interface BoxPayGradeData {
    token: string,
}
export const BoxPayGrade = (json: BoxPayGradeData): any => http.httpPost({
    url: httpApi.pay.BoxPayGrade,
    json
})

// 充值账号校验
interface CheckUserData {
    token: string,
    account: string
}
export const CheckUser = (json: CheckUserData): any => http.httpPost({
    url: httpApi.pay.CheckUser,
    json
})

interface PayData {
    token: string,
    uid: number,
    pay_amount: number,
    props_name: string
}

// 支付宝支付
export const H5AlipayBox = (json: PayData): any => http.httpPost({
    url: httpApi.pay.H5AlipayBox,
    json
})

// 微信支付
export const H5WechatBox = (json: PayData): any => http.httpPost({
    url: httpApi.pay.H5WechatBox,
    json
})

// 金币提现签约
interface UserSignData {
    token: string,
}
export const userSign = (json: UserSignData): any => http.httpPost({
    url: httpApi.pay.userSign,
    json
})

// 用户人脸签约
interface UserSignFaceData {
    uid: number,
}
export const userSignFace = (json: UserSignFaceData): any => http.httpPost({
    url: httpApi.pay.userSignFace,
    json
})

// 金币提现签约查询接口
export const getUserSign = (): any => http.httpPost({
    url: httpApi.pay.getUserSign,
})

// 撤销提现（交易币提现到盒币）
export const cancelApply = (json: UserSignData): any => http.httpPost({
    url: httpApi.pay.cancelApply,
    json
})

// SVIP用户信息查询
interface QuerySvipUserInfoData {
    userId: number,
}
export const querySvipUserInfo = (json: QuerySvipUserInfoData): any => http.httpGet({
    url: httpApi.pay.querySvipUserInfo,
    json
})

// 极速提现申请
interface SpeedUpApplyData {
    type: number,
    money: string,
    alipay_account: string,
    extract_type: number,
    user_coupon: number,
}
export const apiSpeedUpApply = (json: SpeedUpApplyData): any => http.httpPost({
    url: httpApi.pay.SpeedUpApply,
    json
})

export const apiQueryFastCashSvipPopupInfo = (): any => http.httpGet({
    url: httpApi.pay.queryFastCashSvipPopupInfo
})
